import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { Button, Modal } from "react-bootstrap";
import { useCreateVertical, useGetCompanies, useUpdateVertical } from "../../../../../backend/masters";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../../../common/Table";
import { ACTIONS, PATTERNS } from "../../../../common/Constants";
import { API_RESULT, ERROR_MESSAGES } from "../../../../../utils/constants";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../../common/FormRenderer";
import { getValue, preventDefault } from "../../../../../utils/common";
import PageLoader from "../../../../shared/PageLoader";
import { GetActionTitle } from "../../Master.constants";
import { ResponseModel } from "../../../../../models/responseModel";

function AddEditVertical({ action, record : data, onClose, onSubmit }: any) {
    const [t] = useState(new Date().getTime());
    const [form, setForm] = useState<any>({});
    const [vertical, setvertical] = useState<any>({ hideButtons: true });
    const { companies } = useGetCompanies({ ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true, is_active_eq: true }, t }, true);
    const { createVertical, creating } = useCreateVertical((vertical: ResponseModel) => {
        if (vertical && vertical.error_messages.length > 0) {
            toast.error(vertical.error_messages.join(', '));
        } else {
            toast.success(`"${vertical.name}" created successfully.`);
            onSubmit();
        }
    }, errorCallback);
    const { updateVertical, updating } = useUpdateVertical((vertical: ResponseModel) => {
        if (vertical && vertical.error_messages.length > 0) {
          toast.error(vertical.error_messages.join(', '));
      } else {
          toast.success(`"${vertical.name}" updated successfully.`);
          onSubmit();
      }
    }, errorCallback);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }

    const schema = {
        fields: [
            {
                component: componentTypes.SELECT,
                name: 'company',
                label: 'Company',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                options: companies,
                content: action !== ACTIONS.ADD ? getValue(vertical, 'company.label') : null
            },
            {
                component: componentTypes.TEXT_FIELD,
                name: 'name',
                label: 'Vertical Name',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    {
                        type: validatorTypes.PATTERN, pattern: PATTERNS.GENERIC,
                        message: 'Should contain only  A-Z, a-z, 0-9, space, hyphen(-) and underscore(_)'
                    }
                ],
                content: null
            },
            {
                component: componentTypes.TEXT_FIELD,
                name: 'short_code',
                label: 'Vertical Code',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.MAX_LENGTH, threshold: 10 },
                    { type: validatorTypes.PATTERN, pattern: /^[a-zA-Z0-9]{2,10}$/, message: 'Should be alphanumeric value of length 2' }
                ],
                styleClass: 'text-uppercase',
                content: null
            },
            {
                component: componentTypes.TEXTAREA,
                name: 'description',
                label: 'Description',
                content: action === null
            }
        ]
    };

    function debugForm(_form: any) {
        setForm(_form);
        setvertical(_form.values);
    }

    function submit(e: any) {
        preventDefault(e);
        if (form.valid) {
            const { id, short_code, name, description, company } = vertical;
            const request: any = {
                short_code: short_code.toUpperCase(),
                name: name.trim(),
                description: (description || '').trim(),
                company_id: company.value
            };

            if (action === ACTIONS.EDIT) {
                request['id'] = data.id;
                updateVertical(request);
            } else {
                createVertical(request);
            }
        }
    }

    useEffect(() => {
        if (data) {
            const { id, name } = data.company || {};
            setvertical({
                ...vertical,
                ...data,
                company: { value: id, label: name }
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Vertical', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={vertical}
                        componentMapper={ComponentMapper}
                        schema={schema}
                        debug={debugForm}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                      <>
                          <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={onClose}>{'Cancel'}</Button>
                          <Button variant="primary" onClick={submit} className="px-4" disabled={!form.valid}>{'Submit'}</Button>
                      </>
                    }
                </Modal.Footer>
            </Modal>
            {
                (creating || updating) &&
                <PageLoader>
                    {creating ? 'Creating Vertical...' : 'Updating Vertical...'}
                </PageLoader>
            }
        </>
    )
}

export default AddEditVertical;